import Vue from 'vue'
import Vuex from 'vuex'

// Import des modules
import sollicitations from './modules/sollicitations'
import user from './modules/user'
import categories from './modules/categories'
import types from './modules/types'
import natures from './modules/natures'
import motifs from './modules/motifs'
import motifCloture from './modules/motifCloture'
import entrees from './modules/entrees'
import programmes from './modules/programmes'
import partenaires from './modules/partenaires'
import collaborateurs from './modules/collaborateurs'
import logements from './modules/logements'
import suivis from './modules/suivis'
import actions from './modules/actions'
import evenements from './modules/evenements'
import pictures from './modules/pictures'
import title from './modules/title'
import moyenAcces from './modules/moyenAcces'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    sollicitations,
    user,
    categories,
    types,
    natures,
    motifs,
    motifCloture,
    entrees,
    programmes,
    partenaires,
    collaborateurs,
    logements,
    suivis,
    actions,
    evenements,
    pictures,
    title,
    moyenAcces
  },
  strict: process.env.NODE_ENV !== 'production'
})
